export function toSnakeCase(str) {
    if (!str) return "";
    return str.toLowerCase().trim().replace(/\s+/g, "_");
  }